// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { play } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-play': IconPlay;
    }
}

/**
 * The icon component for the 'play' icon
 */
export class IconPlay extends Icon {
    public constructor() {
        super(play);
    }
}

registerIcon('icon-play', IconPlay);
export const iconPlayTag = 'nimble-icon-play';
